module.exports = __webpack_public_path__ + "static/media/new.b995bb16.png";